export default __webpack_public_path__ + "static/side-nav-dont-3-32bc6117b5767e806776452e6aace2871054d2709dabc111088b23d610586ae4.png";